(() => {
  if (window.PremierListingCardGallery) {
    window.PremierListingCardGallery.bind(document);
    return;
  }

  const bindGallery = (gallery) => {
    if (gallery.dataset.galleryBound === 'true') return;

    const track = gallery.querySelector('[data-gallery-track]');
    const slides = Array.from(gallery.querySelectorAll('.listing-card__gallery-slide'));
    const current = gallery.querySelector('[data-gallery-current]');
    const previous = gallery.querySelector('[data-gallery-prev]');
    const next = gallery.querySelector('[data-gallery-next]');
    if (!track || slides.length < 2) return;

    gallery.dataset.galleryBound = 'true';

    let index = 0;
    let touchStartX = null;
    let touchStartY = null;
    let suppressLinkUntil = 0;

    const goTo = (nextIndex) => {
      index = (nextIndex + slides.length) % slides.length;
      track.style.transform = `translate3d(-${index * 100}%, 0, 0)`;
      slides.forEach((slide, slideIndex) => {
        slide.setAttribute('aria-hidden', slideIndex === index ? 'false' : 'true');
      });
      if (current) current.textContent = String(index + 1);
    };

    previous?.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      goTo(index - 1);
    });

    next?.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      goTo(index + 1);
    });

    gallery.addEventListener('touchstart', (event) => {
      touchStartX = event.changedTouches[0]?.clientX ?? null;
      touchStartY = event.changedTouches[0]?.clientY ?? null;
    }, { passive: true });

    gallery.addEventListener('touchend', (event) => {
      if (touchStartX === null || touchStartY === null) return;

      const touch = event.changedTouches[0];
      const distanceX = (touch?.clientX ?? touchStartX) - touchStartX;
      const distanceY = (touch?.clientY ?? touchStartY) - touchStartY;
      touchStartX = null;
      touchStartY = null;

      if (Math.abs(distanceX) < 42 || Math.abs(distanceX) <= Math.abs(distanceY)) return;

      suppressLinkUntil = Date.now() + 500;
      event.preventDefault();
      goTo(index + (distanceX < 0 ? 1 : -1));
    }, { passive: false });

    gallery.addEventListener('click', (event) => {
      if (Date.now() > suppressLinkUntil || !event.target.closest('.listing-card__media-link')) return;
      event.preventDefault();
      event.stopPropagation();
    }, true);

    goTo(0);
  };

  const bind = (root = document) => {
    if (root instanceof Element && root.matches('[data-listing-gallery]')) bindGallery(root);
    root.querySelectorAll?.('[data-listing-gallery]').forEach(bindGallery);
  };

  window.PremierListingCardGallery = { bind };
  bind(document);

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node instanceof Element) bind(node);
      });
    });
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', (event) => bind(event.target));
})();
